// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.payrole-outer {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}
.run_pay_role_outer {
  width: 100%;
  height: 448px;
  border: 1px solid #ccc;
  border-radius: 12px;
  background: #f9f9f9;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
}

.pay_role_inner_input_section {
  border: 1px solid rgb(130, 129, 129);
  margin: 10px;
  height: 30px;
  padding: 5px;
}
.select_location_section {
  margin: 10px;
  width: 100px;
  height: 58px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}
.container_payroll_tracker {
  height: 79px;
  border: 1px solid rgb(142, 142, 142);
  display: flex;
  justify-content: space-around;
  margin: 0px 10px 0px 10px;
  border-top: none;
  margin-top: -10px;
}
.num1 {
  border: 1px solid #8c8888;
  border-radius: 50%;
  /* background-color: green; */
  color: rgb(170, 169, 169);
  width: 30px;
  height: 30px;
  display: flex;
  justify-content: space-around;
}
.num1 span {
  margin-top: 2px;
}
.select_location_section p {
  font-size: 8px;
}
.payrollBtn {
  /* border: 1px solid black;  */
  display: flex;
  gap: 66px;
  /* position: absolute; */
  /* bottom: 0;
  top: 460px;
  left: 737px; */
}

.num1.active {
  width: 30px;
  height: 30px;
  background-color: #28a745; /* Example: Blue for active */
  color: white;
  border-color: #28a745;
}

.num1.completed {
  background-color: #28a745; /* Green for completed */
  color: white;
  border-color: #28a745;
}

.num1.completed span::after {
  content: " ✓"; /* Adds a checkmark; you might prefer an icon */
  font-weight: bold;
}

/* --- Payroll Date Edit Section --- */
.payroll-edit-container {
  display: flex;
  align-items: center;
  height: 40px;
}

.payroll-edit-controls {
  display: flex;
  gap: 10px;
  align-items: center;
}

.payroll-edit-select {
  padding: 4px 8px;
  border-radius: 4px;
  border: 1px solid #cbd5e1;
  outline: none;
  font-family: inherit;
}

.payroll-btn-save {
  background-color: #2563eb;
  color: white;
  border: none;
  padding: 5px 12px;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 500;
  transition: background-color 0.2s ease;
}

.payroll-btn-save:hover {
  background-color: #1d4ed8;
}

.payroll-btn-cancel {
  background-color: #e5e7eb;
  color: #374151;
  border: none;
  padding: 5px 12px;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 500;
  transition: background-color 0.2s ease;
}

.payroll-btn-cancel:hover {
  background-color: #d1d5db;
}

.payroll-header-text {
  margin: 0;
  display: flex;
  align-items: center;
}

.payroll-btn-edit {
  margin-left: 15px;
  background-color: transparent;
  border: 1px solid #cbd5e1;
  color: #475569;
  padding: 2px 8px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
  transition: all 0.2s ease;
}

.payroll-btn-edit:hover {
  background-color: #f1f5f9;
  border-color: #94a3b8;
}
`, "",{"version":3,"sources":["webpack://./src/components/ComponentsCss/GenerateSalaryComponent/PayRole/PayRole.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,YAAY;EACZ,YAAY;AACd;AACA;EACE,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,6BAA6B;EAC7B,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,6BAA6B;EAC7B,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,6BAA6B;AAC/B;AACA;EACE,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,8BAA8B;EAC9B,aAAa;EACb,SAAS;EACT,wBAAwB;EACxB;;gBAEc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB,EAAE,6BAA6B;EACxD,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,yBAAyB,EAAE,wBAAwB;EACnD,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,aAAa,EAAE,+CAA+C;EAC9D,iBAAiB;AACnB;;AAEA,sCAAsC;AACtC;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB","sourcesContent":[".payrole-outer {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 4px;\n}\n.run_pay_role_outer {\n  width: 100%;\n  height: 448px;\n  border: 1px solid #ccc;\n  border-radius: 12px;\n  background: #f9f9f9;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);\n}\n\n.pay_role_inner_input_section {\n  border: 1px solid rgb(130, 129, 129);\n  margin: 10px;\n  height: 30px;\n  padding: 5px;\n}\n.select_location_section {\n  margin: 10px;\n  width: 100px;\n  height: 58px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n}\n.container_payroll_tracker {\n  height: 79px;\n  border: 1px solid rgb(142, 142, 142);\n  display: flex;\n  justify-content: space-around;\n  margin: 0px 10px 0px 10px;\n  border-top: none;\n  margin-top: -10px;\n}\n.num1 {\n  border: 1px solid #8c8888;\n  border-radius: 50%;\n  /* background-color: green; */\n  color: rgb(170, 169, 169);\n  width: 30px;\n  height: 30px;\n  display: flex;\n  justify-content: space-around;\n}\n.num1 span {\n  margin-top: 2px;\n}\n.select_location_section p {\n  font-size: 8px;\n}\n.payrollBtn {\n  /* border: 1px solid black;  */\n  display: flex;\n  gap: 66px;\n  /* position: absolute; */\n  /* bottom: 0;\n  top: 460px;\n  left: 737px; */\n}\n\n.num1.active {\n  width: 30px;\n  height: 30px;\n  background-color: #28a745; /* Example: Blue for active */\n  color: white;\n  border-color: #28a745;\n}\n\n.num1.completed {\n  background-color: #28a745; /* Green for completed */\n  color: white;\n  border-color: #28a745;\n}\n\n.num1.completed span::after {\n  content: \" ✓\"; /* Adds a checkmark; you might prefer an icon */\n  font-weight: bold;\n}\n\n/* --- Payroll Date Edit Section --- */\n.payroll-edit-container {\n  display: flex;\n  align-items: center;\n  height: 40px;\n}\n\n.payroll-edit-controls {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n}\n\n.payroll-edit-select {\n  padding: 4px 8px;\n  border-radius: 4px;\n  border: 1px solid #cbd5e1;\n  outline: none;\n  font-family: inherit;\n}\n\n.payroll-btn-save {\n  background-color: #2563eb;\n  color: white;\n  border: none;\n  padding: 5px 12px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-weight: 500;\n  transition: background-color 0.2s ease;\n}\n\n.payroll-btn-save:hover {\n  background-color: #1d4ed8;\n}\n\n.payroll-btn-cancel {\n  background-color: #e5e7eb;\n  color: #374151;\n  border: none;\n  padding: 5px 12px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-weight: 500;\n  transition: background-color 0.2s ease;\n}\n\n.payroll-btn-cancel:hover {\n  background-color: #d1d5db;\n}\n\n.payroll-header-text {\n  margin: 0;\n  display: flex;\n  align-items: center;\n}\n\n.payroll-btn-edit {\n  margin-left: 15px;\n  background-color: transparent;\n  border: 1px solid #cbd5e1;\n  color: #475569;\n  padding: 2px 8px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 12px;\n  transition: all 0.2s ease;\n}\n\n.payroll-btn-edit:hover {\n  background-color: #f1f5f9;\n  border-color: #94a3b8;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
